import { EntityMetadataMap } from '@ngrx/data';

export const KE_MODELS_REGISTRY_ENTITY_NAME = 'keModelsRegistry';

const entityMetadata: EntityMetadataMap = {
  [KE_MODELS_REGISTRY_ENTITY_NAME]: {
    entityDispatcherOptions: { optimisticAdd: false, optimisticUpdate: false },
  },
};

export const keModelsRegistryEntityConfig = {
  entityMetadata,
};
